import clsx from 'clsx';
import React from 'react';
import { useWindowSize } from 'usehooks-ts';

import BenefitImage from 'images/subscription_landing/benefit-image.jpg';

import { WIDTH_SM } from '@utils/constants';

import styles from './styles.module.scss';

const BenefitsSection = () => {
  const { width } = useWindowSize();

  return (
    <div className={styles.benefitsSection}>
      <img src={BenefitImage} alt="Benefits" width={width > 768 ? 466 : 340} />
      <div className={styles.benefitsHeaderContainer}>
        <div className={styles.highlight}>read the best in tech news</div>
        <h2 className={styles.benefitsHeader}>Know what matters—before everyone else finds out</h2>
      </div>
      <div className={clsx(styles.benefitsDetails, styles.detailsText)}>
        Get access to exclusive coverage and read deeply reported stories from the largest dedicated
        newsroom to tech journalism. Deep-dive into topics like venture capital, startups, crypto,
        the creator economy and more with our top reporters and other executives.
      </div>
      <hr className={styles.hr} />
      <div className={styles.descriptionsContainer}>
        <div className={styles.description}>
          <h5 className={styles.detailsHeader}>Editorial Projects and Org Charts</h5>
          <div className={styles.detailsText}>
            Our editorial projects—like the Creator Economy Database, Crypto Power List, The
            Information 50, Enterprise Tech Power List and more—are updated regularly. And with an
            annual subscription, you&rsquo;ll have access to our collection of more than 30 tech
            company org charts.
          </div>
        </div>
        {width > WIDTH_SM ? <div className={styles.vl}></div> : <hr className={styles.hr} />}
        <div className={styles.description}>
          <h5 className={styles.detailsHeader}>The Information Profiles, Directory and Forum</h5>
          <div className={styles.detailsText}>
            Our suite of community tools provide access to one of the most powerful communities of
            professionals in the world. Follow and join in on serious discussions about tech,
            finance and media with others who share your same passion for these topics.
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
